// extracted by mini-css-extract-plugin
export default {"field":"Wyel8","switcher":"Ku1hh","item":"naUtW","itemActive":"mBvSp","text":"xxTSm"};